import { Manager2 } from '~/models/manager2';

export const manager2Service = {
	fetch: async (): Promise<Manager2.Model | null> => {
		const params = {
			fields: ['*', 'photo.*', 'form.*'],
		};

		try {
			const response = await $fetch<Manager2.Model>(Manager2.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Manager2:', error);

			return null;
		}
	},
};
